import React, { useMemo } from "react";
import {
  Container,
  Content,
  Copyright,
  ExternalLink,
  Flex,
  IconImage,
  InternalLink,
  Legal,
  SectionLabel,
  Column,
  Grid,
} from "./styles";

const currentYear = new Date().getFullYear();

function LinkComponent({ link, className, children }) {
  let Comp = <></>;
  const props = { className };

  if (link?.[0] === "/") {
    props.to = link;
    Comp = InternalLink;
  } else {
    props.href = link;
    props.target = "_blank";
    Comp = ExternalLink;
  }

  return <Comp {...props}>{children}</Comp>;
}

function LinkSection({ label, links }) {
  return (
    <Column className="links-section">
      <SectionLabel className="section-label">{label}</SectionLabel>
      {links?.map(({ footerBarLinkLabel, footerBarSectionLink }, idx) => (
        <LinkComponent
          key={`link-section-${idx}`}
          link={footerBarSectionLink}
          className="section-link"
        >
          {footerBarLinkLabel}
        </LinkComponent>
      ))}
    </Column>
  );
}

export default function FooterComponent({
  background,
  fontColor,
  footerBarLinkSections = [],
  footerBarIconButtons = [],
}) {
  const linkSectionPercentColWidth =
    100 - (1 / footerBarLinkSections.length + 1) * 100;
  const linkSectionContent = useMemo(
    () =>
      footerBarLinkSections?.map(
        ({ footerBarSectionLabel = "", footerBarSectionLinks = [] }, idx) => (
          <LinkSection
            key={`link-section-${idx}`}
            label={footerBarSectionLabel}
            links={footerBarSectionLinks}
          />
        )
      ),
    [footerBarLinkSections]
  );

  const iconButtonsSection = (
    <>
      {footerBarIconButtons?.map(
        ({ footerBarNavButtonIcon, footerBarNavButtonUrl }, idx) => {
          return (
            <LinkComponent
              link={footerBarNavButtonUrl}
              className="icon-button-link"
              key={`footerIconButtons-${idx}`}
            >
              <IconImage item={footerBarNavButtonIcon} />
            </LinkComponent>
          );
        }
      )}
    </>
  );

  return (
    <Container
      bg_color={background}
      font_color={fontColor}
      link_section_pct_col_width={linkSectionPercentColWidth}
    >
      <Content>
        <Column className="left-col">
          <Grid className="link-section-container">{linkSectionContent}</Grid>
        </Column>
        <Column className="right-col">
          <Flex className="app-links-container">{iconButtonsSection}</Flex>
        </Column>
      </Content>
      <Legal>
        <Copyright>
          <p>
            Copyright 2014–{currentYear} Savant Systems, Inc | *The GE monogram
            is a trademark of General Electric Company used under license.
          </p>
        </Copyright>
      </Legal>
    </Container>
  );
}
